import '~styles/index.scss';
import 'react-toastify/dist/ReactToastify.css';

import Box from '@mui/material/Box';
import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import AppHeader from './AppHeader/AppHeader';

const UnauthenticatedLayout = () => {
  return (
    <>
      <div className="wrapper">
        <AppHeader />
        <Box component="main" sx={{ px: 5 }} className={classNames({ loading: false })}>
          <Outlet />
        </Box>
      </div>
    </>
  );
};

export default UnauthenticatedLayout;
